// External map links for a trip location. Returns null when coords are unset.
export function mapLinks(lat, lng) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  const a = lat.toFixed(6);
  const b = lng.toFixed(6);
  return {
    // Google Earth web — opens a 3D view centered on the spot.
    earth: `https://earth.google.com/web/@${a},${b},0a,12000d,35y,0h,0t,0r`,
    // Google Maps satellite (data=!3m1!1e3 forces the satellite layer).
    maps: `https://www.google.com/maps/@${a},${b},14z/data=!3m1!1e3`,
  };
}
